import { render, staticRenderFns } from "./TemperatureLastXDays.vue?vue&type=template&id=c8e5c0ba&"
import script from "./TemperatureLastXDays.vue?vue&type=script&lang=ts&"
export * from "./TemperatureLastXDays.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports